export default __webpack_public_path__ + "static/media/994812acd133291bfa7ceeea540c73841582283746948.1fbefda2.webp";